import React, { useState, useEffect } from 'react';
import {
  MDBCard,
  MDBCardTitle,
  MDBContainer,
  MDBRow,
  MDBIcon,
  MDBCol,
} from 'mdbreact';
import { Link } from 'react-router-dom';

import NavMenu from '../../components/NavMenu';
import { useHistory } from 'react-router-dom';

import Api from '../../services/api';

import efetivo from '../../assets/efetivo.jpg';
import efetivofoco from '../../assets/efetivofoco.jpeg';
import alocacao from '../../assets/alocacao.jpg';
import cargos from '../../assets/cargos.jpg';
import { getData, getPerfil, logout } from '../../services/auth';

const backgrounds = {};
backgrounds.efetivo = efetivo;
backgrounds.efetivofoco = efetivofoco;
backgrounds.alocacao = alocacao;
backgrounds.cargos = cargos;

// const insereImg = url => {
// const img = require(`${url}`);
// console.log(`url(${img})`);
// require(url);
// return `url(${img})`;
// };

// const teste = kk => {
//   return `url(${require(kk)})`;
// };
// const teste = async nome => {.≥/;.""

//   const ttt = await require(nome);
//   return ttt;
// };
// import

// import { isAuthenticated } from '../../services/auth';

// import img from '../../assets/images.jpg';

// import endereco_imagem from '../../assets/efetivofoco.jpeg';
// const importarImagens = (name, diretory) => {
//   return (const name = require(diretory))
// };
// import { Container } from './styles';

export default function App(props) {
  const [modulos, setModulos] = useState([]);
  let history = useHistory();
  // import `${img.modulo.endereco_imagem.split('/')[3].split('.')[0])}` from `${img.modulo.endereco_imagem}`

  const acesso = async () => {
    try {
      const response = await Api.get('/card-acesso');

      setModulos(response.data);
    } catch (error) {
      logout();
      history.push('/');
    }

    // console.log('data', response.data);
    // response.data.map(img => {
    //   console.log(teste);
    // });
    // var splits = myString.split(' ', 3);
  };

  useEffect(() => {
    acesso();
  }, []);

  // modulos.map((modulo)=> {
  //   // modulo.map((acesso) => {
  //     modulo.acessos.map((acessos) => {
  //       console.log(acessos.modulo)
  //     })
  //   // })
  //   })
  // insereImg('../../assets/alocacao.jpg');
  return (
    <>
      <NavMenu />
      <MDBContainer fluid>
        {/* espacamento  */}

        <MDBRow className="d-flex justify-content-start align-items-stretch pt-4">
          {modulos == [] ? (
            <MDBCol col="12" md="6">
              Vc nao tem acesso'
            </MDBCol>
          ) : (
            modulos.map(gerenciaModulo => (
              <MDBCol
                col="12"
                md="6"
                key={gerenciaModulo.id}
                // d-flex aqui + h-100 no card: sem isso, dois módulos lado a
                // lado ficam com alturas diferentes quando um tem mais atalhos
                // que o outro, e a grade desalinha.
                className="d-flex flex-column mb-4"
              >
                <MDBCard
                  style={{
                    // A foto identifica o módulo de relance e é o que dá
                    // personalidade à home — por isso ela fica. O que o texto
                    // não pode é depender dela para ter contraste: este véu
                    // branco (mais denso no topo e no rodapé, onde estão o
                    // título e os atalhos) garante leitura sobre qualquer foto,
                    // inclusive as que ainda vierem a ser cadastradas.
                    backgroundImage:
                      `linear-gradient(to bottom, rgba(255,255,255,0.62) 0%, ` +
                      `rgba(255,255,255,0.28) 45%, rgba(255,255,255,0.66) 100%), ` +
                      `url(${window.location.origin}/api/${gerenciaModulo.modulo.endereco_imagem})`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    color: 'rgba(0,0,0,0.6)',
                  }}
                  // justify-content-start (e não -between): os cards têm altura
                  // uniforme, então o que sobra tem que ir para o RODAPÉ. Com
                  // -between o excedente virava um vão entre o título e os
                  // atalhos — um módulo de 4 atalhos ao lado de um de 7 ficava
                  // com um buraco no meio, que antes a descrição escondia.
                  className="justify-content-start card-body text-center h-100 mb-0"
                >
                  <MDBCardTitle className="h5">
                    {gerenciaModulo.modulo.titulo}
                  </MDBCardTitle>

                  {/* flex-wrap: sem ele, TODOS os atalhos do módulo são
                      espremidos numa linha só. Gestão de Ocorrências passou de
                      6 itens e os rótulos começaram a colidir no celular. */}
                  <div
                    style={{ borderTop: '1px rgba(0,0,0,0.1) solid' }}
                    className="d-flex flex-row flex-wrap justify-content-around pt-3"
                  >
                    {gerenciaModulo.modulo.funcionalidades.map(botoes => (
                      <Link
                        key={botoes.id}
                        to={botoes.rota}
                        className="d-flex flex-column align-items-center justify-content-end mb-3"
                        style={{
                          color: 'rgba(0,0,0,0.6)',
                          // Célula fluida em vez de largura fixa. 84px é o piso
                          // (mantém os ícones alinhados quando o rótulo ocupa
                          // duas linhas) e a célula cresce até 160px para gastar
                          // o espaço sobrando: 60,6% dos usuários enxergam dois
                          // módulos ou menos, e com 3 atalhos metade do card
                          // ficava vazia. Uma regra só, sem condicional por
                          // quantidade.
                          flex: '1 1 84px',
                          maxWidth: 160,
                        }}
                      >
                        <span
                          style={{
                            // 10px era ilegível a um braço de distância, que é
                            // como o sistema é usado: agente em pé, no posto.
                            // O contraste aqui já passa em AA (5,74:1) — o
                            // defeito era o tamanho.
                            fontSize: 14,
                            marginBottom: 5,
                            textAlign: 'center',
                            lineHeight: 1.2,
                          }}
                        >
                          {botoes.nome}
                        </span>

                        {/* A coluna `icone` guarda dois formatos ("fas fa-list"
                            e "chart-pie") e o MDBIcon prefixa `fa fa-`, o que
                            produz "fa fa-fas fa-list". Parece classe quebrada,
                            mas `fa` + `fa-list` é a combinação da Font Awesome
                            4, que `styles/global.js` carrega por último — e é
                            a fonte com que o SEGOV inteiro desenha. O #342
                            trocou este bloco para `fas`/`far` (Font Awesome 5)
                            acreditando que 40 dos 41 ícones não apareciam;
                            medido depois no mesmo CSS, todos apareciam. A
                            troca deixava a home numa família tipográfica e o
                            resto do sistema em outra, com cheios e contornos
                            misturados na mesma grade. Migrar para FA5 é
                            decisão do sistema inteiro (#343), não desta tela. */}
                        <MDBIcon icon={botoes.icone} size="2x" />
                      </Link>
                    ))}
                    {/* <Link
                      to="/usuario/add"
                      className="d-flex flex-column align-items-center blue-grey-text"
                    >
                      <span style={{ fontSize: 10, marginBottom: 5 }}>
                        Adicionar
                      </span>
                      <MDBIcon far icon="plus-square" size="2x" />
                    </Link> */}
                    {/* <Link
                      to="/estatisticas"
                      className="d-flex flex-column align-items-center blue-grey-text"
                    >
                      <span style={{ fontSize: 10, marginBottom: 5 }}>
                        Estatísticas
                      </span>
                      <MDBIcon icon="chart-pie" size="2x" />
                    </Link> */}
                    {/* <Link
                      to="/usuarios"
                      className="d-flex flex-column align-items-center blue-grey-text"
                    >
                      <span style={{ fontSize: 10, marginBottom: 5 }}>
                        Listar
                      </span>
                      <MDBIcon icon="list" size="2x" />
                    </Link> */}
                  </div>
                </MDBCard>
              </MDBCol>
            ))
          )}

          {/* <MDBCol col="12" md="6">
            <br />

            <MDBCard
              style={{
                backgroundImage: `url(${efetivo})`,
                backgroundSize: 'cover',
              }}
              className="justify-content-between card-body  blue-grey-text text-center"
            >
              <MDBCardTitle className="h5">GESTÃO DE EFETIVO</MDBCardTitle>
              <MDBCardText className="grey-text text-left">
                Registrar o ingresso do servidor na Secretária de Governo.
                <br />
                <br />
              </MDBCardText>

              <div
                style={{ borderTop: '1px rgba(0,0,0,0.1) solid' }}
                className="flex-row d-flex justify-content-around  pt-3 mt-3"
              >
                <Link
                  to="/usuario/add"
                  className="d-flex flex-column align-items-center blue-grey-text"
                >
                  <span style={{ fontSize: 10, marginBottom: 5 }}>
                    Adicionar
                  </span>
                  <MDBIcon far icon="plus-square" size="2x" />
                </Link>
                <Link
                  to="/estatisticas"
                  className="d-flex flex-column align-items-center blue-grey-text"
                >
                  <span style={{ fontSize: 10, marginBottom: 5 }}>
                    Estatísticas
                  </span>
                  <MDBIcon icon="chart-pie" size="2x" />
                </Link>
                <Link
                  to="/usuarios"
                  className="d-flex flex-column align-items-center blue-grey-text"
                >
                  <span style={{ fontSize: 10, marginBottom: 5 }}>Listar</span>
                  <MDBIcon icon="list" size="2x" />
                </Link>
              </div>
            </MDBCard>
          </MDBCol> */}

          {/* <MDBCol col="12" md="6">
            <br />
            <MDBCard
              style={{
                backgroundImage: `url(${alocacao})`,
                backgroundSize: 'cover',
              }}
              className="justify-content-between card-body blue-grey-text text-center"
            >
              <MDBCardTitle className="h5">ALOCAÇÃO</MDBCardTitle>

              <MDBCardText className="grey-text text-left">
                Criação e Gerenciamento das operaçoes e suboperações.
                <br />
                <br />
              </MDBCardText>

              <div
                style={{ borderTop: '1px rgba(0,0,0,0.1) solid' }}
                className="flex-row d-flex justify-content-around pt-3 mt-3"
              >
                <Link
                  to="/lotacao"
                  className="d-flex flex-column align-items-center blue-grey-text"
                >
                  <span style={{ fontSize: 10, marginBottom: 5 }}>Lotação</span>

                  <MDBIcon icon="list" size="2x" />
                </Link>
                <Link
              to="/alocacao"
              className="d-flex flex-column align-items-center blue-grey-text"
            >
              <span style={{ fontSize: 10, marginBottom: 5 }}>Alocação</span>
              <MDBIcon far icon="plus-square" size="2x" />
            </Link>

                <Link
                  to="/escala-calendario"
                  className="d-flex flex-column align-items-center blue-grey-text"
                >
                  <span style={{ fontSize: 10, marginBottom: 5 }}>
                    Calendário
                  </span>

                  <MDBIcon icon="list" size="2x" />
                </Link>
              </div>
            </MDBCard>
          </MDBCol> */}
        </MDBRow>
        <br />

        <MDBRow className="d-flex justify-content-start">
          {/* <MDBCard
          style={{
            backgroundImage: `url(${frota2})`,
            backgroundSize: 'cover',
          }}
          className="justify-content-between card-body col-12 col-md-3 mr-2 ml-2 mt-3 blue-grey-text text-center"
        >
          <MDBCardTitle className="h5">GESTÃO DE FROTA</MDBCardTitle>

          <MDBCardText className="grey-text text-left">
            Controle dos veículos empregados na Secretária de Governo.
          </MDBCardText>

          <div
            style={{ borderTop: '1px rgba(0,0,0,0.1) solid' }}
            className="flex-row d-flex justify-content-around pt-3 mt-3 "
          >
            <Link
              to="/add-frota"
              className="d-flex flex-column align-items-center blue-grey-text"
            >
              <span style={{ fontSize: 10, marginBottom: 5 }}>Veículos</span>
              <MDBIcon far icon="plus-square" size="2x" />
            </Link>
            <Link
              to="/frota"
              className="d-flex flex-column align-items-center blue-grey-text"
            >
              <span style={{ fontSize: 10, marginBottom: 5 }}>Relatórios</span>

              <MDBIcon icon="list" size="2x" />
            </Link>
          </div>
        </MDBCard>

        <MDBCard
          style={{
            backgroundImage: `url(${parteDiaria})`,
            backgroundSize: 'cover',
          }}
          className="justify-content-between card-body col-12 col-md-3 mr-2 ml-2 mt-3 blue-grey-text text-center"
        >
          <MDBCardTitle className="h5">GESTÃO DE PATRIMÔNIO</MDBCardTitle>

          <MDBCardText className="grey-text text-left">
            Registrar o ingresso de novos cargos e administrar os existentes,
            Assim como calcular o custo operacional da Operação.
          </MDBCardText>

          <div
            style={{ borderTop: '1px rgba(0,0,0,0.1) solid' }}
            className="flex-row d-flex justify-content-around pt-3 mt-3 "
          >
            <Link
              to="/add-patrimonio"
              className="d-flex flex-column align-items-center blue-grey-text"
            >
              <span style={{ fontSize: 10, marginBottom: 5 }}>Adicionar</span>
              <MDBIcon far icon="plus-square" size="2x" />
            </Link>
            <Link
              to="/patrimonio"
              className="d-flex flex-column align-items-center blue-grey-text"
            >
              <span style={{ fontSize: 10, marginBottom: 5 }}>Listar</span>

              <MDBIcon icon="list" size="2x" />
            </Link>
          </div>
        </MDBCard> */}
          {/* <MDBCol col="12" md="6">
            <MDBCard
              style={{
                backgroundImage: `url(${ocorrenciaImg})`,
                backgroundSize: 'cover',
              }}
              className="justify-content-between card-body  mt-md-0 blue-grey-text text-center"
            >
              <MDBCardTitle className="h5">GESTÃO DE SERVIÇO</MDBCardTitle>
              <MDBCardText className="grey-text text-left">
                Registrar o ingresso do servidor na Secretária de Governo.
                <br />
                <br />
              </MDBCardText>

              <div
                style={{ borderTop: '1px rgba(0,0,0,0.1) solid' }}
                className="flex-row d-flex justify-content-around  pt-3 mt-3"
              >
                <Link
                  to="/controle-de-presenca"
                  className="d-flex flex-column align-items-center blue-grey-text"
                >
                  <span style={{ fontSize: 10, marginBottom: 5 }}>
                    Controle de presença
                  </span>
                  <MDBIcon far icon="plus-square" size="2x" />
                </Link>
                <Link
                to="/usuarios"
                className="d-flex flex-column align-items-center blue-grey-text"
              >
                <span style={{ fontSize: 10, marginBottom: 5 }}>
                  Estatísticas
                </span>
                <MDBIcon icon="chart-pie" size="2x" />
              </Link>






                <Link
                  to="/usuarios"
                  className="d-flex flex-column align-items-center blue-grey-text"
                >
                  <span style={{ fontSize: 10, marginBottom: 5 }}>Listar</span>
                  <MDBIcon icon="list" size="2x" />
                </Link>
              </div>
            </MDBCard>
          </MDBCol> */}
        </MDBRow>

        {/* <MDBRow className="d-flex justify-content-center">
        <MDBCard
          style={{
            backgroundImage: `url(${monitoramento})`,
            backgroundSize: 'cover',
          }}
          className="justify-content-between card-body col-12 col-md-3 mr-2 ml-2 mt-3 blue-grey-text text-center"
        >
          <MDBCardTitle className="h5">MONITORAMENTO</MDBCardTitle>

          <MDBCardText className="grey-text text-left">
            Controle de cameras dos postos fiscais no CICC, criação de
            relatórios e despacho de demandas.
          </MDBCardText>

          <div
            style={{ borderTop: '1px rgba(0,0,0,0.1) solid' }}
            className="flex-row d-flex justify-content-around pt-3 mt-3 "
          >
            <Link
              to="/usuarios"
              className="d-flex flex-column align-items-center blue-grey-text"
            >
              <span style={{ fontSize: 10, marginBottom: 5 }}>Veículos</span>
              <MDBIcon icon="car" size="2x" />
            </Link>
            <Link
              to="/usuarios"
              className="d-flex flex-column align-items-center blue-grey-text"
            >
              <span style={{ fontSize: 10, marginBottom: 5 }}>Relatórios</span>

              <MDBIcon icon="clipboard" size="2x" />
            </Link>
          </div>
        </MDBCard>

        <MDBCard
          style={{
            backgroundImage: `url(${parteDiaria})`,
            backgroundSize: 'cover',
          }}
          className="justify-content-between card-body col-12 col-md-5 mr-2 ml-2 mt-3 blue-grey-text text-center"
        >
          <MDBCardTitle className="h5">PARTE DIÁRIA</MDBCardTitle>

          <MDBCardText className="grey-text text-left">
            Alterações diárias como: falta de servidores, avaria veicular,
            acidente e etc.
          </MDBCardText>

          <div
            style={{ borderTop: '1px rgba(0,0,0,0.1) solid' }}
            className="flex-row d-flex justify-content-around pt-3 mt-3"
          >
            <Link
              to="/usuarios"
              className="d-flex flex-column align-items-center blue-grey-text"
            >
              <span style={{ fontSize: 10, marginBottom: 5 }}>Adicionar</span>
              <MDBIcon far icon="plus-square" size="2x" />
            </Link>
            <Link
              to="/usuarios"
              className="d-flex flex-column align-items-center blue-grey-text"
            >
              <span style={{ fontSize: 10, marginBottom: 5 }}>
                Estatísticas
              </span>
              <MDBIcon icon="chart-pie" size="2x" />
            </Link>
            <Link
              to="/usuarios"
              className="d-flex flex-column align-items-center blue-grey-text"
            >
              <span style={{ fontSize: 10, marginBottom: 5 }}>Listar</span>
              <MDBIcon icon="list" size="2x" />
            </Link>
          </div>
        </MDBCard>
        <MDBCard
          style={{
            backgroundImage: `url(${ocrImg})`,
            backgroundSize: 'cover',
          }}
          className="justify-content-between card-body col-12 col-md-3 mr-2 ml-2 mt-3 blue-grey-text text-center"
        >
          <MDBCardTitle className="h5">ANÁLISES DE CAMERAS OCR</MDBCardTitle>

          <MDBCardText className="grey-text text-left">
            Ferramenta de análise dos meta dados das câmeras OCR das rodovias do
            estado do Rio de Janeiro.
          </MDBCardText>

          <div
            style={{ borderTop: '1px rgba(0,0,0,0.1) solid' }}
            className="flex-row d-flex justify-content-around pt-3 mt-3"
          >
            <Link
              to="/usuarios"
              className="d-flex flex-column align-items-center blue-grey-text"
            >
              <span style={{ fontSize: 10, marginBottom: 5 }}>
                Estatísticas
              </span>
              <MDBIcon icon="chart-pie" size="2x" />
            </Link>
          </div>
        </MDBCard>
      </MDBRow>

      <MDBRow className="d-flex justify-content-center">
        <MDBCard
          style={{
            backgroundImage: `url(${ocorrenciaImg})`,
            backgroundSize: 'cover',
          }}
          className="justify-content-between card-body col-12 col-md-5 mr-2 ml-2 mt-3 blue-grey-text text-center"
        >
          <MDBCardTitle className="h5">
            GESTÃO DE PRESTAÇÃO DE SERVIÇOS
          </MDBCardTitle>

          <MDBCardText className="grey-text text-left">
            Sistema de acompanhamento dos serviços prestados por empresas
            contratadas, fazendo a gestão do Acordo do Nivel de Serviço
          </MDBCardText>

          <div
            style={{ borderTop: '1px rgba(0,0,0,0.1) solid' }}
            className="flex-row d-flex justify-content-around pt-3 mt-3"
          >
            <Link
              to="/usuarios"
              className="d-flex flex-column align-items-center blue-grey-text"
            >
              <span style={{ fontSize: 10, marginBottom: 5 }}>Adicionar</span>
              <MDBIcon far icon="plus-square" size="2x" />
            </Link>
            <Link
              to="/usuarios"
              className="d-flex flex-column align-items-center blue-grey-text"
            >
              <span style={{ fontSize: 10, marginBottom: 5 }}>
                Estatísticas
              </span>
              <MDBIcon icon="chart-pie" size="2x" />
            </Link>
            <Link
              to="/usuarios"
              className="d-flex flex-column align-items-center blue-grey-text"
            >
              <span style={{ fontSize: 10, marginBottom: 5 }}>Listar</span>
              <MDBIcon icon="list" size="2x" />
            </Link>
          </div>
        </MDBCard>

        <MDBCard
          style={{
            backgroundImage: `url(${gerenciaImg})`,
            backgroundSize: 'cover',
          }}
          className="justify-content-between card-body col-12 col-md-3 mr-2 ml-2 mt-3 blue-grey-text text-center"
        >
          <MDBCardTitle className="h5">DENÚNCIAS</MDBCardTitle>

          <MDBCardText className="grey-text text-left">
            Informações de denúncias da Central Disque Denúncia
          </MDBCardText>
          <div
            style={{ borderTop: '1px rgba(0,0,0,0.1) solid' }}
            className="flex-row d-flex justify-content-around pt-3 mt-3"
          >
            <Link
              to="/usuarios"
              className="d-flex flex-column align-items-center blue-grey-text"
            >
              <span style={{ fontSize: 10, marginBottom: 5 }}>
                Estatísticas
              </span>
              <MDBIcon icon="chart-pie" size="2x" />
            </Link>
          </div>
        </MDBCard>
        <MDBCard
          style={{
            backgroundImage: `url(${cargosImg})`,
            backgroundSize: 'cover',
          }}
          className="justify-content-between card-body col-12 col-md-3 mr-2 ml-2 mt-3 blue-grey-text text-center"
        >
          <MDBCardTitle className="h5">GESTÃO DE PATRIMÔNIO</MDBCardTitle>

          <MDBCardText className="grey-text text-left">
            Registrar o ingresso de novos cargos e administrar os existentes,
            Assim como calcular o custo operacional da Operação
          </MDBCardText>

          <div
            style={{ borderTop: '1px rgba(0,0,0,0.1) solid' }}
            className="flex-row d-flex justify-content-around pt-3 mt-3"
          >
            <Link
              to="/usuarios"
              className="d-flex flex-column align-items-center blue-grey-text"
            >
              <span style={{ fontSize: 10, marginBottom: 5 }}>
                Estatísticas
              </span>
              <MDBIcon icon="chart-pie" size="2x" />
            </Link>
          </div>
        </MDBCard>
      </MDBRow> */}

        {/* <MDBRow className="d-flex justify-content-center">

        <MDBCard
          style={{
            backgroundImage: `url(${nuint})`,
            backgroundSize: 'cover',
            opacity: '0.5',
          }}
          className="justify-content-between card-body col-12 col-md-5 mr-2 ml-2 mt-3 white-text text-center"
        >
          <MDBCardTitle className="h5"> </MDBCardTitle>
          <br />
          <br />
          <MDBCardText className="grey-text text-left" />

          <div
            style={{ borderTop: '1px rgba(0,0,0,0.1) solid' }}
            className="flex-row d-flex justify-content-around pt-3 mt-3"
          >
            <Link
              to="/usuarios"
              className="d-flex flex-column align-items-center white-text"
            >
              <span style={{ fontSize: 10, marginBottom: 5 }}>Adicionar</span>
              <MDBIcon far icon="plus-square" size="2x" />
            </Link>
            <Link
              to="/usuarios"
              className="d-flex flex-column align-items-center white-text"
            >
              <span style={{ fontSize: 10, marginBottom: 5 }}>
                Estatísticas
              </span>
              <MDBIcon icon="chart-pie" size="2x" />
            </Link>
            <Link
              to="/usuarios"
              className="d-flex flex-column align-items-center white-text"
            >
              <span style={{ fontSize: 10, marginBottom: 5 }}>Listar</span>
              <MDBIcon icon="list" size="2x" />
            </Link>
          </div>
        </MDBCard>
      </MDBRow> */}
        <br />
        <br />
      </MDBContainer>
    </>
  );
}
